import { useContext, useState } from "react";
import axios from "../axios";
import { UserContext } from "../../components/context/UseContext";
import { useInfo } from "../useInfo";
import { toast } from "sonner";

export const useProfile = () => {
  const { setLoading } = useInfo();
  const { setProfile, profile, token } = useContext(UserContext);
  const [firstName, setFirstName] = useState(profile?.first_name);
  const [lastName, setLastName] = useState(profile?.last_name);
  const [telePhone, setTelephone] = useState(profile?.phone_number || null);
  const [isLoading, setIsLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);

  const getProfileInfo = async (token, isArena) => {
    try {
      const res = await axios.get(
        `/audiences/get-profile?is_arena=${isArena}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );
      if (res.status === 200) {
        setProfile(res.data);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err?.response?.data?.message || "Failed to load profile");
    }
  };

  const handleEditProfile = async () => {
    try {
      setIsLoading(true);

      const payload = {
        ...(firstName?.trim() ? { first_name: firstName.trim() } : {}),
        ...(lastName?.trim() ? { last_name: lastName.trim() } : {}),
        ...(telePhone?.fullNumber
          ? { phone_number: telePhone.fullNumber }
          : {}),
      };

      if (Object.keys(payload).length === 0) {
        setIsLoading(false);
        return;
      }

      const res = await axios.post(
        "/audiences/account-settings/profile/edit",
        JSON.stringify(payload),
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      if (res.status === 200) {
        getProfileInfo(token, true);
        toast.success(res.data.message);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      if (error.response.data.message.includes("SQLSTATE[23000]")) {
        toast.error("This phone number is already in use");
      } else toast.error(error.response.data.message);
    }
  };

  const handleUploadProfileImage = async (image) => {
    const profileImage = new FormData();
    profileImage.append("image", image);

    try {
      setIsUploading(true);
      const res = await axios.post(
        "/audiences/account-settings/profile/upload-image",
        profileImage,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.status === 200) {
        await getProfileInfo(token, true);
        toast.success(res.data.message);
        setIsUploading(false);
      }
    } catch (error) {
      setIsUploading(false);
      toast.error(error.response.data.message);
    }
  };

  return {
    handleUploadProfileImage,
    isUploading,
    getProfileInfo,
    handleEditProfile,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    telePhone,
    setTelephone,
    isLoading,
  };
};
